/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import axios from 'axios'
import {getChildDetail, getFileBox} from '../../../api/modules/kontrak'

import swal from 'sweetalert'
import {CloseButton} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'

const KontrakSub: React.FC = () => {
  const intl = useIntl()

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [show5, setShow5] = useState(false)
  const [show6, setShow6] = useState(false)
  const [show7, setShow7] = useState(false)
  const [show8, setShow8] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)
  const handleClose3 = () => setShow3(false)
  const handleShow3 = () => setShow3(true)
  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => setShow4(true)
  const handleClose5 = () => setShow5(false)
  const handleShow5 = () => setShow5(true)
  const handleClose6 = () => setShow6(false)
  const handleShow6 = () => setShow6(true)
  const handleClose7 = () => setShow7(false)
  const handleShow7 = () => setShow7(true)
  const handleClose8 = () => setShow8(false)
  const handleShow8 = () => setShow8(true)

  const Approve = () => {
    swal({
      title: `${t('aprroveSuccess')}`,
      icon: 'success',
    })
    handleClose5()
    handleClose6()
  }

  const Reject = () => {
    swal({
      title: `${t('tolakNegosiasiBerhasil')}`,
      icon: 'success',
    })
    handleClose4()
  }

  let role = 1

  const {t} = useTranslation()

  const [detail, setDetail] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [orderId, setOrderId] = useState('')
  const [subDetail, setsubDetail] = useState<any[]>([])
  const [subDetails, setsubDetails] = useState<any[]>([])
  const [productType, setproductType] = useState<any>()
  const [productName, setproductName] = useState<any>()
  const [producSpek, setproducSpek] = useState<any>()
  const [kuantum, setKuantum] = useState<any>()
  const [incoterm, setIncoterm] = useState<any>()
  const [pricePpn, setPricePpn] = useState<any>()
  const [wilayah, setWilayah] = useState<any>()
  const [gudang, setGudang] = useState<any>()
  const [kuantumSisa, setKuantumSisa] = useState<any>()
  const [id, setId] = useState<any>()
  const [status, setStatus] = useState<any>()
  const [paymentStatus, setPaymentStatus] = useState<any>()
  const [Produsen, setProdusen] = useState<any>()
  const [priceBefore, setPriceBefore] = useState<any>()
  const [ppn, setPpn] = useState<any>()
  const [kuantumDo, setKuantumDo] = useState<any>()
  const [soNumber, setSoNumber] = useState<any>()
  const [soNumberSap, setSoNumberSap] = useState<any>()
  const [invoice, setInvoice] = useState<any>()
  const [orderCode, setOrderCode] = useState<any>()

  useEffect(() => {
    const getDetail = async () => {
      let subIndex = 0
      subIndex = parseInt(localStorage.getItem('subIndex') || '0')
      setLoading(true)
      const res = await getChildDetail(localStorage.getItem('sub'))
      const data = res.data.data
      setDetail(data)
      setOrderId(data.id)
      setsubDetail(data.order_sub_details)
      setPage(data.current_page)
      setPer(data.per_page)
      setLoading(false)
      setNumberURL(data.links)
      setproductType(res.data.data.product_type)
      setproductName(res.data.data.product_name)
      setproducSpek(res.data.data.product_spec)
      setKuantum(res.data.data.fixed_quantum)
      setIncoterm(res.data.data.incoterm1.code)
      setPricePpn(res.data.data.price_after_ppn)
      setWilayah(res.data.data.region_id)
      setGudang(res.data.data.plant)
      setKuantumSisa(res.data.data.fixed_quantum - res.data.data.quantum_realisazied)
      setId(res.data.data.so_items[0].sales_order.id)
      setStatus(res.data.data.so_items[0].sales_order.status_text)
      setPaymentStatus(res.data.data.so_items[0].sales_order.status_pembayaran_text)
      setProdusen(res.data.data.produsen.name)
      setPriceBefore(res.data.data.price_before_ppn)
      setPpn(res.data.data.ppn)
      setKuantumDo(res.data.data.quantum_do)
      setSoNumber(res.data.data.so_items[0].sales_order.so_number)
      setSoNumberSap(res.data.data.so_items[0].sales_order.sap_number)
    }
    getDetail()
  }, [])

  const [box, setBox] = useState<any[]>([])

  const handleBox = (box: any) => {
    localStorage.setItem('box', box)
    handleShow()
  }

  useEffect(() => {
    const getBox = async () => {
      const res = await getFileBox(localStorage.getItem('box'))
      const data = res.data.data
      setBox(data)
    }

    getBox()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: `• ${t('Management')} • ${t('Kontrak')} • ${t('Sub Detail')}`})}
      </PageTitle>
      <div className='card p-5'>
        {/* begin::Header */}
        <Link
          to='/management/kontrak/detail'
          className='text-danger fs-5'
          style={{marginTop: '2.5rem'}}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr002.svg' className='icon-back' />
          {t('kontrak-kembali')}
        </Link>
        <p>
          <span className='card-label fw-bold fs-2 mb-1'>Sub {t('kontrak-detailJudul')}</span>
        </p>

        <div>
          <div className='mt-5' style={{width: '50%'}}>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-item')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-item')}
                  disabled
                  value={orderId}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-jenis')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-jenis')}
                  disabled
                  value={productType}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-nama')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-nama')}
                  disabled
                  value={productName}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-spek')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  as='textarea'
                  style={{height: '40px'}}
                  placeholder={t('kontrak-spek')}
                  disabled
                  value={producSpek}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-kuantum')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-kuantum')}
                  disabled
                  value={kuantum}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-incoterm')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control type='text' placeholder='Incoterm' disabled value={incoterm} />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-hargaPpn')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-hargaPpn')}
                  disabled
                  value={pricePpn}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-wilayah')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-wilayah')}
                  disabled
                  value={wilayah}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-Gudang')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-Gudang')}
                  disabled
                  value={gudang}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('kontrak-kuantumS')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('kontrak-kuantumS')}
                  disabled
                  value={kuantumSisa}
                />
              </Col>
            </Row>
          </div>

          <div className='table-responsive' style={{marginTop: '3rem'}}>
            {/* Table Head */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead className='border-bottom'>
                <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                  <th className='td-order-1 text-center'>{t('kontrak-no')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-aksi')}</th>
                  <th className='td-order-2 text-center'>Status</th>
                  <th className='td-order-2 text-center'>{t('kontrak-pembayaran')} Status</th>
                  <th className='td-order-2 text-center'>{t('kontrak-soNomor')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-soNomor')} SAP*</th>
                  <th className='td-order-2 text-center'>{t('kontrak-fakturN')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-kodeBooking')}</th>
                  <th className='td-order-2 text-center'>Sales Org</th>
                  <th className='td-order-2 text-center'>{t('kontrak-incoterm')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-produk')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-spesifikasi')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-hargaPPN')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-ppn')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-hargaSPPN')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-kuantum')} SO</th>
                  <th className='td-order-2 text-center'>{t('kontrak-wilayah')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-kuantum')} DO</th>
                </tr>
              </thead>
              <tbody>
                <tr className='d-flex jusify-content-center w-100 align-items-center'>
                  <th className='td-order-1 text-center'>{id}</th>
                  <td className='td-order-2 text-center '>
                    <div className='d-flex justify-content-center'>
                      <a
                        href='#'
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('order-lampiran')}
                        onClick={() => handleBox(id)}
                      >
                        <KTSVG
                          path='/media/icons/duotune/archive-fill.svg'
                          className='svg-icon-3'
                        />
                      </a>
                      <Modal
                        show={show}
                        onHide={handleClose}
                        backdrop='static'
                        keyboard={false}
                        centered
                        size='lg'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('order-fileBox')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Row>
                            <div className='table-responsive'>
                              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                <thead className='border-bottom'>
                                  <tr className=''>
                                    <th className='text-center'>{t('order-noo')}</th>
                                    <th className='text-center'>{t('order-namaFile')}</th>
                                    <th className='text-center'>{t('order-jenisFile')}</th>
                                    <th className='text-center'>{t('order-keterangan')}</th>
                                    <th className='text-center'>{t('order-tglUpload')}</th>
                                    <th className='text-center'>{t('order-user')}</th>
                                    <th className='text-center'>{t('order-aksi')}</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {box.map((item, index) => (
                                    <tr key={item?.name ?? index} className=''>
                                      <td className='text-center'>
                                        <label>{index + 1}</label>
                                      </td>
                                      <td className='text-center'>
                                        <label>{item.name}</label>
                                      </td>
                                      <td className='text-center'>
                                        <label>{t(item.file_type)}</label>
                                      </td>
                                      <td className='text-center'>
                                        <label>{item.description}</label>
                                      </td>
                                      <td className='text-center'>
                                        <label>{item.created_at?.slice(0, 10)}</label>
                                      </td>
                                      <td className='text-center'>
                                        <label>{item.user_id}</label>
                                      </td>
                                      <td className='text-center'>
                                        <button
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('unduh')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/arrow-down-square-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </Row>
                        </Modal.Body>
                      </Modal>
                    </div>
                  </td>
                  <td className='td-order-2 text-center'>{status}</td>
                  <td className='td-order-2 text-center'>{paymentStatus}</td>
                  <td className='td-order-2 text-center'>{soNumber}</td>
                  <td className='td-order-2 text-center'>{soNumberSap}</td>
                  <td className='td-order-2 text-center'>{t('nomorPembayaran')}</td>
                  <td className='td-order-2 text-center'>{t('Kode-booking')}</td>
                  <td className='td-order-2 text-center'>{Produsen}</td>
                  <td className='td-order-2 text-center'>{incoterm}</td>
                  <td className='td-order-2 text-center'>{productName}</td>
                  <td className='td-order-2 text-center'>{t('kontrak-spesifikasi')}</td>
                  <td className='td-order-2 text-center'>{priceBefore}</td>
                  <td className='td-order-2 text-center'>{ppn}</td>
                  <td className='td-order-2 text-center'>{pricePpn}</td>
                  <td className='td-order-2 text-center'>{t('Kuantum')} SO</td>
                  <td className='td-order-2 text-center'>{wilayah}</td>
                  <td className='td-order-2 text-center'>{kuantumDo}</td>
                </tr>
              </tbody>
            </table>
            {/* End Table Head */}
          </div>
        </div>
      </div>
    </>
  )
}

export {KontrakSub}
